import { BasePageableV2 } from '../../models/base/base-pageable.model';

export class BasePageableV2Builder {
  private constructor(
    private totalNumberOfElements: number,
    private totalNumberOfPages: number,
    private pageSize: number,
    private currentPage: number
  ) {}

  static aBasePageable(): BasePageableV2Builder {
    return new BasePageableV2Builder(0, 0, 1, 0);
  }

  withTotalNumberOfElements(totalNumberOfElements: number): this {
    if (totalNumberOfElements < 0) {
      throw new Error(`Cannot build BasePageable with totalNumberOfElements ${totalNumberOfElements}`);
    }
    this.totalNumberOfElements = totalNumberOfElements;
    return this;
  }

  withTotalNumberOfPages(numberOfPages: number): this {
    if (numberOfPages <= 0) {
      throw new Error(`Cannot build BasePageable with numberOfElementsPerPage ${numberOfPages}`);
    }
    this.totalNumberOfPages = numberOfPages;
    return this;
  }

  withCurrentPage(pageIndex: number): this {
    if (pageIndex < 0) {
      throw new Error(`Cannot build BasePageable with pageIndex ${pageIndex}`);
    }
    this.currentPage = pageIndex;
    return this;
  }

  withPageSize(pageSize: number): this {
    if (pageSize < 1) {
      throw new Error(`Cannot build BasePageable with pageSize ${pageSize}`);
    }
    this.pageSize = pageSize;
    return this;
  }

  build(): BasePageableV2 {
    if (this.currentPage > this.totalNumberOfPages) {
      throw new Error(`Cannot build BasePageable with pageIndex ${this.currentPage} and totalNumberOfPages ${this.totalNumberOfPages}`);
    }

    return {
      totalElements: this.totalNumberOfElements,
      totalPages: this.totalNumberOfPages,
      currentPage: this.currentPage,
      pageSize: this.pageSize
    };
  }
}
